function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "scales"
}, React.createElement("path", {
  d: "M24.43,46.231c0.067-0.108,0.144-0.22,0.231-0.326C24.566,46.005,24.487,46.115,24.43,46.231z",
  fill: "currentColor"
}), React.createElement("path", {
  d: "M32.065,48.344c-6.528,0.385-11.625,3.574-11.625,7.448h12.953h12.952 c0-3.874-5.094-7.063-11.623-7.448c-0.437-0.026-0.879-0.037-1.329-0.037C32.946,48.307,32.502,48.318,32.065,48.344z",
  fill: "currentColor"
}), React.createElement("path", {
  d: "M47.203,56.882H33.391h-13.81c-0.856,0-1.549,0.957-1.549,2.132c0,1.175,0.693,2.132,1.549,2.132 h13.81h13.812c0.855,0,1.549-0.957,1.549-2.132C48.753,57.839,48.058,56.882,47.203,56.882z",
  fill: "currentColor"
}), React.createElement("path", {
  d: "M22.786,30.662H0c0,6.29,5.101,11.392,11.392,11.392C17.685,42.054,22.786,36.952,22.786,30.662z",
  fill: "currentColor"
}), React.createElement("polygon", {
  points: "11.402,13.247 20.537,29.939 22.786,29.939 11.404,9.139 0,29.939 2.25,29.939  ",
  fill: "currentColor"
}), React.createElement("path", {
  d: "M66.786,30.662H44c0,6.29,5.101,11.392,11.392,11.392C61.685,42.054,66.786,36.952,66.786,30.662z",
  fill: "currentColor"
}), React.createElement("polygon", {
  points: "55.402,13.247 64.537,29.939 66.786,29.939 55.404,9.139 44,29.939 46.25,29.939  ",
  fill: "currentColor"
}), React.createElement("path", {
  d: "M33.392,0c-0.949,0-1.719,0.612-1.719,1.371v2.13v1.828v41.941c0.566-0.022,1.14-0.034,1.719-0.034 c0.583,0,1.155,0.011,1.721,0.034V5.329V3.502v-2.13C35.113,0.612,34.342,0,33.392,0z",
  fill: "currentColor"
}), React.createElement("path", {
  d: "M58.891,4.447H34.858h-2.931H7.895c-0.54,0-0.979,0.77-0.979,1.723c0,0.947,0.439,1.717,0.979,1.717 h24.032h2.931h24.032c0.54,0,0.979-0.769,0.979-1.717C59.869,5.217,59.431,4.447,58.891,4.447z",
  fill: "currentColor"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_1"
});

var SvgIconScales = function SvgIconScales(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 66.786 61.146",
    style: {
      enableBackground: "new 0 0 66.786 61.146"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconScales, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-scales.2f10796e.svg";
export { ForwardRef as ReactComponent };